import axiosInstance from "api/axiosInstance";

import type { Association, AssociationCreateRequest, AssociationListParams } from "api/types/associations.types";

const BASE = "/server/buccl_lessons/api/v1/associations/";

export const associationsService = {
  list: (params?: AssociationListParams) => axiosInstance.get<Association[]>(BASE, { params }),

  get: (id: number) => axiosInstance.get<Association>(`${BASE}${id}/`),

  create: (payload: AssociationCreateRequest) => axiosInstance.post<Association>(BASE, payload),

  update: (id: number, payload: Partial<AssociationCreateRequest>) => axiosInstance.patch<Association>(`${BASE}${id}/`, payload),

  remove: (id: number) => axiosInstance.delete(`${BASE}${id}/`),
};
